import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import { inchToString } from '../../../lib/unitConversions';

export const PrepregSummary = (props) => {
  const {
    glassThickness,
    thickness,
    pressedThickness,
    lengthUnit
  } = props;
  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container justify="flex-end">
          <pre>
            Glass thickness:
            {' '}
            {inchToString(glassThickness, lengthUnit)}
            <br />
            Prepreg Thickness:
            {' '}
            {inchToString(thickness, lengthUnit)}
            {process.env.NODE_ENV === 'development' ? ( 
              <div>
                Pressed Thickness:
                {' '}
                {inchToString(pressedThickness, lengthUnit)}
              </div>
            ) : null}
          </pre>
        </Grid>
      </Grid>
    </Grid>
  );
}

PrepregSummary.propTypes = {
  glassThickness: PropTypes.number.isRequired,
  thickness: PropTypes.number.isRequired,
  pressedThickness: PropTypes.number.isRequired,
  lengthUnit: PropTypes.string.isRequired,
}

export default PrepregSummary;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/PrepregSummary.js